<template>
    <BasePromotionCard
        title="Ask your network for feedback"
        description="Send a short question to colleagues and review the responses together."
        cta-label="Send a feedback request"
        cta-href="/feedback-questions">
        <template #icon>
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
        </template>
        <template v-if="data.suggested_question" #draft> <span class="font-medium text-violet-800">Drafted:</span> "{{ data.suggested_question }}" </template>
    </BasePromotionCard>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { PromoteFeedbackRequestResult } from "../../types";
import BasePromotionCard from "./BasePromotionCard.vue";

const props = defineProps<{ result: PromoteFeedbackRequestResult; toolName: string }>();

const data = computed<PromoteFeedbackRequestResult>(() => props.result);
</script>
